import { render } from "./Index_news.vue?vue&type=template&id=fb55459e&scoped=true"
import script from "./Index_news.vue?vue&type=script&lang=js"
export * from "./Index_news.vue?vue&type=script&lang=js"

import "./Index_news.vue?vue&type=style&index=0&id=fb55459e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb55459e"

export default script